import React from 'react'

import classnames from 'classnames/bind'
import delve from 'dlv'
import { Text } from 'components/typo'
import css from './styles.module.scss'
import { useSectionsContext } from '../SectionsProvider'

const cx = classnames.bind(css)

const SectionsMap = ({ className }) => {
  const [sectionsState] = useSectionsContext()
  
return (
  <ul className={cx(className, css.SectionsMap)}>
    {Object.keys(sectionsState).map((sectionKey) => {
        return (
          <Text
            tag="li"
            size="small"
            theme="waikawa-gray"
            className={cx(css.section, {
              active: sectionsState[sectionKey].active,
            })}
            key={sectionKey}
          >
            <button
              className={css.sectionButton}
              onClick={() => {
                const node = delve(sectionsState, `${sectionKey}.ref.current`)

                if (node) {
                  window.scrollTo({
                    behavior: 'smooth',
                    top: node.getBoundingClientRect().top + window.scrollY - 95,
                  })
                }
              }}
            >
              {delve(sectionsState, `${sectionKey}.text`)}
            </button>
          </Text>
        )
      })}
  </ul>
  )
}

SectionsMap.defaultProps = {}

export default SectionsMap
